import { Column, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import StarIcon from '~/images/icons/StarIcon';

interface IRatingContentProps {
  professionalSkills: number;
  interpersonalSkills: number;
  timeManagement: number;
}

export const RatingContent = ({
  professionalSkills,
  interpersonalSkills,
  timeManagement,
}: IRatingContentProps) => (
  <Column alignItems="center" justifyContent="center" gap={16}>
    <Text bold fontSize={18}>
      Average Rating
    </Text>
    {[
      { label: 'Professional Skills', value: professionalSkills },
      { label: 'Interpersonal Skills', value: interpersonalSkills },
      { label: 'Time Management', value: timeManagement },
    ].map(({ label, value }) => (
      <Column key={label} alignItems="center" gap={4}>
        <Text bold>{label}</Text>
        <Row alignItems="center" justifyContent="center" gap={4}>
          {Array.from({ length: 5 }).map((_, i) => (
            <StarIcon
              key={`${label}-${i}`}
              width={18}
              height={18}
              color={i < Math.floor(value) ? undefined : Colors.neutral_200}
            />
          ))}
          <Text>{value.toFixed(1)}</Text>
        </Row>
      </Column>
    ))}
  </Column>
);
